export const timeoutPromise = async (promise, timeout) =>
{
	let timeoutHandle;

	const _timeoutPromise = new Promise((_, reject) =>
	{
		timeoutHandle = setTimeout(() => reject(new Error('Promise timed out')), timeout);
	});

	return Promise.race([ promise, _timeoutPromise ]).then((result) =>
	{
		clearTimeout(timeoutHandle);

		return result;
	});
};
